"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tabs;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _rcTabs = _interopRequireWildcard(require("rc-tabs"));
var _ScrollableInkTabBar = _interopRequireDefault(require("rc-tabs/lib/ScrollableInkTabBar"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TabContent = _interopRequireDefault(require("rc-tabs/lib/TabContent"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StyledTabs = require("./StyledTabs");
var _ykbStyledComponents = require("../ykb-styled-components");
var _ykbUtils = require("ykb-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Tabs(props) {
  var className = props.className,
    size = props.size,
    _props$type = props.type,
    type = _props$type === void 0 ? 'line' : _props$type,
    tabPosition = props.tabPosition,
    children = props.children,
    tabBarExtraContent = props.tabBarExtraContent,
    tabBarStyle = props.tabBarStyle,
    hideAdd = props.hideAdd,
    onTabClick = props.onTabClick,
    onPrevClick = props.onPrevClick,
    onNextClick = props.onNextClick,
    _props$animated = props.animated,
    animated = _props$animated === void 0 ? false : _props$animated,
    ellipsis = props.ellipsis,
    onEdit = props.onEdit,
    onChange = props.onChange,
    prefixCls = props.prefixCls,
    hideTabBar = props.hideTabBar,
    hiddenTabs = props.hiddenTabs;
  var createNewTab = function createNewTab(targetKey) {
    if (onEdit) {
      onEdit(targetKey, 'add');
    }
  };
  var removeTab = function removeTab(targetKey, e) {
    e.stopPropagation();
    if (!targetKey) return;
    if (onEdit) {
      onEdit(targetKey, 'remove');
    }
  };
  var handleChange = function handleChange(activeKey) {
    if (onChange) {
      onChange(activeKey);
    }
  };
  var _ref = (0, _typeof2.default)(animated) === 'object' ? {
      inkBarAnimated: animated.inkBar,
      tabPaneAnimated: animated.tabPane
    } : {
      inkBarAnimated: animated,
      tabPaneAnimated: animated
    },
    inkBarAnimated = _ref.inkBarAnimated,
    tabPaneAnimated = _ref.tabPaneAnimated;
  if (type !== 'line') {
    tabPaneAnimated = 'animated' in props ? tabPaneAnimated : false;
  }
  var _renderTabBar = function renderTabBar(styledPrefix) {
    if (hideTabBar) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    if (type === 'editable-card') {
      if (!hideAdd) {
        tabBarExtraContent = !tabBarExtraContent ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_StyledTabs.NewTabIcon, {
          name: "plus",
          className: "".concat(styledPrefix, "-new-tab"),
          onClick: createNewTab
        }), tabBarExtraContent) : tabBarExtraContent;
      }
    }
    tabBarExtraContent = tabBarExtraContent ? /*#__PURE__*/_react.default.createElement(_StyledTabs.ExtraContent, {
      className: "".concat(styledPrefix, "-extra-content")
    }, tabBarExtraContent) : null;
    return /*#__PURE__*/_react.default.createElement(_ScrollableInkTabBar.default, {
      inkBarAnimated: inkBarAnimated,
      extraContent: tabBarExtraContent,
      onTabClick: onTabClick,
      onPrevClick: onPrevClick,
      onNextClick: onNextClick,
      style: tabBarStyle,
      prevIcon: tabPosition === 'left' || tabPosition === 'right' ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "angle-up"
      }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "angle-left"
      }),
      nextIcon: tabPosition === 'left' || tabPosition === 'right' ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "angle-down"
      }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "angle-right"
      })
    });
  };
  var renderEditableCardTab = function renderEditableCardTab(child, styledPrefix) {
    var closable = child.props.closable;
    closable = typeof closable === 'undefined' ? true : closable;
    var closeIcon = closable ? /*#__PURE__*/_react.default.createElement(_StyledTabs.CloseIconWrapper, null, /*#__PURE__*/_react.default.createElement(_StyledTabs.CloseIcon, {
      name: "close",
      className: "".concat(styledPrefix, "-tab-close-icon"),
      onClick: function onClick(e) {
        return removeTab(child.key, e);
      }
    })) : null;
    var isEllipsis = !(0, _ykbUtils.isNullOrUndefined)(ellipsis) || child.props && !(0, _ykbUtils.isNullOrUndefined)(child.props.ellipsis);
    var ellipsisWidth = isEllipsis ? getEllipsisWidth(child) : null;
    var cardTitle = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(styledPrefix, "-tab-title"), true), "".concat(styledPrefix, "-tab-ellipsis-title"), isEllipsis));
    return /*#__PURE__*/_react.default.createElement(_StyledTabs.TabButton, {
      className: closable ? undefined : "".concat(styledPrefix, "-tab-unclosable")
    }, /*#__PURE__*/_react.default.createElement(_StyledTabs.TabTitle, {
      className: cardTitle,
      $width: ellipsisWidth
    }, child.props.tab), closeIcon);
  };
  var renderEllipsisTab = function renderEllipsisTab(child, styledPrefix) {
    var width = getEllipsisWidth(child);
    return /*#__PURE__*/_react.default.createElement(_StyledTabs.TabButton, null, /*#__PURE__*/_react.default.createElement(_StyledTabs.TabTitle, {
      className: "".concat(styledPrefix, "-tab-ellipsis-title"),
      $width: width
    }, child.props.tab));
  };
  var getEllipsisWidth = function getEllipsisWidth(child) {
    var propsWidth = child.props && (0, _typeof2.default)(child.props.ellipsis) === 'object' ? child.props.ellipsis.width : null;
    var ellipsisWidth = (0, _typeof2.default)(ellipsis) === 'object' ? ellipsis.width : null;
    var defaultWidth = propsWidth || ellipsisWidth || 100;
    return defaultWidth;
  };
  var renderChildren = function renderChildren(styledPrefix) {
    var preparedChildren = [];
    _react.default.Children.forEach(children, function (child, index) {
      if (!child || child.props.hideTab || hiddenTabs !== null && hiddenTabs !== void 0 && hiddenTabs.includes(child.key)) return;
      var tab = null;
      var isEllipsis = !(0, _ykbUtils.isNullOrUndefined)(ellipsis) || child.props && !(0, _ykbUtils.isNullOrUndefined)(child.props.ellipsis);
      if (type === 'editable-card') {
        tab = renderEditableCardTab(child, styledPrefix);
      } else if (isEllipsis) {
        tab = renderEllipsisTab(child, styledPrefix);
      }
      if (/*#__PURE__*/_react.default.isValidElement(tab)) preparedChildren.push(/*#__PURE__*/(0, _react.cloneElement)(child, {
        tab: tab,
        key: child.key || index
      }));else preparedChildren.push(child);
    });
    return preparedChildren;
  };
  var cls = (0, _classnames.default)(className, {
    'tab-card': type.indexOf('card') >= 0,
    'tab-vertical': tabPosition === 'left' || tabPosition === 'right',
    'tab-horizontal': !(tabPosition === 'left' || tabPosition === 'right'),
    'tab-noAnimation': !animated,
    'tab-bottom': tabPosition === 'bottom'
  });
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledTabs.StyledContainer, {
      theme: theme,
      size: size,
      tabPosition: tabPosition,
      type: type,
      prefixCls: prefixCls
    }, function (styledPrefix) {
      return /*#__PURE__*/_react.default.createElement(_rcTabs.default, (0, _extends2.default)({}, props, {
        className: cls,
        tabBarPosition: tabPosition,
        renderTabBar: function renderTabBar() {
          return _renderTabBar(styledPrefix);
        },
        renderTabContent: function renderTabContent() {
          return /*#__PURE__*/_react.default.createElement(_TabContent.default, {
            animated: tabPaneAnimated,
            animatedWithMargin: true
          });
        },
        onChange: handleChange,
        prefixCls: styledPrefix
      }), renderChildren(styledPrefix));
    });
  });
}
Tabs.defaultProps = {
  hideAdd: false,
  animated: false,
  disabled: false,
  tabPosition: 'top',
  hideTabBar: false,
  hiddenTabs: []
};
Tabs.TabPane = _rcTabs.TabPane;
Tabs.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  hideAdd: _propTypes.default.bool,
  defaultActiveKey: _propTypes.default.string,
  animated: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  tabPosition: _propTypes.default.string,
  ellipsis: _propTypes.default.oneOfType([_propTypes.default.shape({
    width: _propTypes.default.number
  }), _propTypes.default.bool]),
  prefixCls: _propTypes.default.string,
  /**
   * small, medium, large
   **/
  size: _propTypes.default.string,
  activeKey: _propTypes.default.string,
  hideTabBar: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  hiddenTabs: _propTypes.default.arrayOf(_propTypes.default.string)
};